import { render, staticRenderFns } from "./ProgressBars.vue?vue&type=template&id=06b09a5a&"
import script from "./ProgressBars.vue?vue&type=script&lang=js&"
export * from "./ProgressBars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports